import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, isValidElement } from "react";
import { ChevronDown } from "@vfit/ui/icons";
import { AccordionNavigationType } from "@vfit/shared/models";
import { StyledAccordion, Title, TitleText, IconSpan, SubtitleText, ContentText } from "./accordion.style";
var Accordion = function(props) {
    var title = props.title, content = props.content, background = props.background, padding = props.padding, borderColor = props.borderColor, textColor = props.textColor, fontFamily = props.fontFamily, fontSize = props.fontSize, fontWeight = props.fontWeight, iconColor = props.iconColor, iconSize = props.iconSize, highlightColor = props.highlightColor, enableHighlight = props.enableHighlight, _accordionNavigationType = props.accordionNavigationType, accordionNavigationType = _accordionNavigationType === void 0 ? AccordionNavigationType.MENU : _accordionNavigationType, lineHeight = props.lineHeight;
    var ref = useState(false), isShowing = ref[0], setIsShowing = ref[1];
    var handleClick = function() {
        setIsShowing(function(prevState) {
            return !prevState;
        });
    };
    var contentAccordion = function() {
        return content.map(function(item, index) {
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ isValidElement(item) && item,
                    !/*#__PURE__*/ isValidElement(item) && /*#__PURE__*/ _jsxs("div", {
                        children: [
                            item.subtitle && /*#__PURE__*/ _jsx(SubtitleText, {
                                children: item.subtitle
                            }),
                            /*#__PURE__*/ _jsx(ContentText, {
                                children: item.text
                            })
                        ]
                    }, "acc".concat(index + 1))
                ]
            });
        });
    };
    return /*#__PURE__*/ _jsxs(StyledAccordion, {
        background: background,
        padding: padding,
        borderColor: borderColor,
        isMenu: accordionNavigationType === AccordionNavigationType.MENU,
        children: [
            /*#__PURE__*/ _jsxs(Title, {
                onClick: handleClick,
                children: [
                    /*#__PURE__*/ _jsx(TitleText, {
                        isMenu: accordionNavigationType === AccordionNavigationType.MENU,
                        fontFamily: fontFamily,
                        fontWeight: fontWeight,
                        fontSize: fontSize,
                        lineHeight: lineHeight,
                        color: isShowing && enableHighlight ? highlightColor : textColor,
                        children: title
                    }),
                    /*#__PURE__*/ _jsx(IconSpan, {
                        color: isShowing && enableHighlight ? highlightColor : iconColor,
                        size: iconSize,
                        className: " ".concat(isShowing ? "showing" : "", " "),
                        children: /*#__PURE__*/ _jsx(ChevronDown, {})
                    })
                ]
            }),
            isShowing && contentAccordion()
        ]
    });
};
export default Accordion;
